export interface JobBoardDragPayload {
  type: 'MOVE_WORK_ORDER' | 'NEW_WORK_SCOPE'
  workOrderId?: number
  duration?: number
  currentLeaderId?: number | null
  scope?: any
}

let activeJobBoardDrag: JobBoardDragPayload | null = null

export function setActiveJobBoardDrag(payload: JobBoardDragPayload | null) {
  activeJobBoardDrag = payload
}

export function getActiveJobBoardDrag(): JobBoardDragPayload | null {
  return activeJobBoardDrag
}
